// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialGradeState,
    GradeSchema,
    GradeFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const Grade = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [grade, setGrade] = useState(InitialGradeState);
    const [formFields, setFormFields] = useState(GradeFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };
    const getGrade = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.GRADES + `/${id}`);
        const data = await response.json();
        setGrade(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewGrade = values.id === undefined;
        const url = isNewGrade ? EntityConstants.GRADES : EntityConstants.GRADES + `/${values.id}`;
        const method = isNewGrade ? post : put;
        const response = await method(url, { grade: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewGrade ? MessageContants.GRADE_CREATED : MessageContants.GRADE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getSchoolsByCompanies();
        if (id !== undefined) {
            getGrade(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={grade}
            validationSchema={GradeSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.GRADE_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.GRADE_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>}
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

Grade.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Grade;
